import { useEffect, useRef, useState } from "react";
import bellIcon from "../../assets/images/bell-icon.svg";
import profileIcon from "../../assets/images/profile-icon.png";
import allImgPaths from "assets/images";
import useAppState from "context/useAppState";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import UserProfile from "./modal/UserProfile";
import { getUserProfile } from "services/user";
import UserProfile from "./modals/UserProfile";
// import ChangePassword from "./modal/ChangePassword";
import useOnClickOutside from "hooks/common/useOnClickOutside";
import ChangePassword from "./modals/ChangePassword";
import MonitorIcon from "@mui/icons-material/Monitor";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  getNotifications as fetchNotificationsApi,
  getUnreadNotificationCount,
  markNotificationAsRead as markReadApi,
  markAllNotificationsAsRead as markAllReadApi,
  deleteNotification as deleteNotifApi,
  deleteAllNotifications as deleteAllNotifApi,
} from "services/monitoring";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { HELP_BUTTON_PATHS } from "utils/constant";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  PROJECT_LIST_WALKTHROUGHS,
  FIND_COVERED_PRODUCT_WALKTHROUGHS,
  VIJILIZATIONS_TAB_WALKTHROUGHS,
  VIJILIZATION_DETAIL_WALKTHROUGHS,
  VIEW_MORE_DETAIL_WALKTHROUGHS,
  ANNOTATION_PAGE_WALKTHROUGHS,
  HEATMAP_WALKTHROUGHS,
  Walkthrough,
} from "utils/walkthroughs";

export interface Props {
  title?: string;
  count?: number;
  isChildEle?: boolean;
  type?: any;
  showMonitorButton?: boolean;
  onMonitorClick?: () => void;
  isMonitoringActive?: boolean;
  onNotificationClick?: (notification: any) => void;
  showBellIcon?: boolean;
}

const Header = ({
  title = "",
  count = 0,
  isChildEle = false,
  type = null,
  showMonitorButton = false,
  onMonitorClick,
  isMonitoringActive = false,
  onNotificationClick,
  showBellIcon = true,
}: Props) => {
  const [userProfile, setUserProfile] = useState<any>({});
  const [showUserProfile, setShowUserProfile] = useState<boolean>(false);
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
  const [showHelpButton, setShowHelpButton] = useState<boolean>(false);
  const [showCreditWarning, setShowCreditWarning] = useState<boolean>(false);
  const [showCreditTooltip, setShowCreditTooltip] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();

  // const { setHasRetrievedTeams } = useAppState('selectTeam');
  const { fetchTeamCredits } = useAppState("billing");
  const [teamCredits, setTeamCredits] = useState<number | null>(null);
  const [creditThreshold, setCreditThreshold] = useState<number>(10);

  const [fetchNewData, setFetchNewData] = useState(false);

  const [isShow, setisShow] = useState(false);
  const [isShowNotification, setIsShowNotification] = useState(false);
  const {
    headerData,
    isActiveSection,
    walkthroughState,
    getWalkthroughActions,
  } = useAppState("vijilize");

  // Guided-walkthrough menu state.
  const [showWalkthroughMenu, setShowWalkthroughMenu] =
    useState<boolean>(false);
  // While gating "How to Vijilize", which prerequisite we're waiting on.
  const [vijilizeGateStage, setVijilizeGateStage] = useState<
    null | "await-source" | "await-target"
  >(null);
  const [pendingVijilizeWalkthrough, setPendingVijilizeWalkthrough] =
    useState<Walkthrough | null>(null);
  // Timer that starts the tour after the Add modal closes; held in a ref so
  // normal re-renders don't cancel it, but unmount/navigation can.
  const resumeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Whether the gated Add modal has been seen open, so we can detect a cancel
  // (modal opened then closed) vs. it never having opened yet.
  const addModalWasOpenRef = useRef<boolean>(false);

  const handleProfileMenu = () => {
    setisShow(!isShow);
  };
  const handleNotificationMenu = () => {
    setIsShowNotification(!isShowNotification);
  };
  const handleLogout = () => {
    localStorage.clear();
    // setHasRetrievedTeams(false);
    navigate("/login");
  };

  // useEffect(() => {
  // 	const userName = JSON.parse(localStorage.getItem('userData') as string)
  // 	setName(userName.name);

  // 	const userData = {
  // 		name: userName?.name,
  // 		profile_image: userName?.profile_image,
  // 		email: localStorage.getItem('userEmail') || ''
  // 	}
  // 	setUserProfile(userData)
  // }, [showUserProfile])

  useEffect(() => {
    fetchUserData();
  }, [fetchNewData]);

  // Auto-show change password modal on forced reset
  useEffect(() => {
    const mustReset = localStorage.getItem("must_reset_password");
    if (mustReset === "true") {
      setShowChangePassword(true);
    }
  }, []);

  useEffect(() => {
    const getTeamCredits = async () => {
      const result = await fetchTeamCredits();
      if (result && typeof result === "object") {
        setTeamCredits(result.credits);
        setCreditThreshold(result.creditThreshold ?? 10);
      } else {
        setTeamCredits(result ?? null);
      }
    };
    getTeamCredits();
  }, [fetchTeamCredits]);

  useEffect(() => {
    // Check if user is admin
    const selectedTeam = JSON.parse(
      localStorage.getItem("selectedTeam") as string
    );
    setIsAdmin(selectedTeam?.currentRole === "Admin");
  }, []);

  useEffect(() => {
    const isFindCoveredProductPage = location.pathname.endsWith(
      HELP_BUTTON_PATHS.FIND_COVERED_PRODUCT
    );

    setShowHelpButton(
      location.pathname.endsWith(HELP_BUTTON_PATHS.PROJECT) ||
        (isFindCoveredProductPage &&
          (isActiveSection === 0 || isActiveSection === 1)) ||
        walkthroughState?.page === "vijilization-detail" ||
        walkthroughState?.page === "view-more-detail" ||
        walkthroughState?.page === "annotation" ||
        walkthroughState?.page === "heatmap"
    );

    // Show credit warning on all pages
    setShowCreditWarning(true);
  }, [location.pathname, isActiveSection, walkthroughState?.page]);

  const fetchUserData = async () => {
    const { data } = await getUserProfile();

    const userData = {
      name: data?.name,
      profile_image: data?.profile_image,
      email: data?.email,
    };

    setUserProfile(userData);

    let updatedUserData = JSON.parse(
      localStorage.getItem("userData") as string
    );
    updatedUserData = {
      ...updatedUserData,
      name: data.name,
      profile_image: data.profile_image,
    };
    localStorage.setItem("userData", JSON.stringify(updatedUserData));

    setFetchNewData(false);
  };

  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadCount, setUnreadCount] = useState<number>(0);

  const getTeamId = () => {
    try {
      const selectedTeam = JSON.parse(
        localStorage.getItem("selectedTeam") as string
      );
      return selectedTeam?.currentTeamId || selectedTeam?._id || "";
    } catch {
      return "";
    }
  };

  const fetchNotifications = async () => {
    const teamId = getTeamId();
    if (!teamId) return;
    try {
      const [notifRes, countRes] = await Promise.all([
        fetchNotificationsApi(teamId, 1, 20),
        getUnreadNotificationCount(teamId),
      ]);
      const notifData: any = notifRes;
      const countData: any = countRes;
      setNotifications(notifData?.notifications || notifData?.data?.notifications || []);
      setUnreadCount(countData?.count ?? countData?.data?.count ?? 0);
    } catch {
      // Silently fail — notifications are non-critical
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000); // Poll every 60s
    return () => clearInterval(interval);
  }, []);

  const markAllAsRead = async () => {
    const teamId = getTeamId();
    if (!teamId) return;
    try {
      await markAllReadApi(teamId);
      setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
      setUnreadCount(0);
    } catch {}
  };

  const markAsRead = async (id: string) => {
    try {
      await markReadApi(id);
      setNotifications((prev) =>
        prev.map((n) => (n._id === id || n.id === id ? { ...n, is_read: true } : n))
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch {}
  };

  const deleteNotif = async (e: React.MouseEvent, id: string) => {
    e.stopPropagation();
    try {
      await deleteNotifApi(id);
      const wasUnread = notifications.find((n) => (n._id === id || n.id === id) && !n.is_read);
      setNotifications((prev) => prev.filter((n) => n._id !== id && n.id !== id));
      if (wasUnread) setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch {}
  };

  const clearAllNotifs = async () => {
    const teamId = getTeamId();
    if (!teamId) return;
    try {
      await deleteAllNotifApi(teamId);
      setNotifications([]);
      setUnreadCount(0);
    } catch {}
  };

  const breadcrumbItems: any[] = [];

  if (isChildEle) {
    if (headerData) {
      const {
        projectDetail,
        claimAnalysis,
        vijilize,
        claimChart,
        portfolioDetail,
      } = headerData;
      if (type === "project") {
        if (projectDetail && projectDetail?.title && projectDetail?.id) {
          breadcrumbItems.push({
            name: `Project`,
            url: `/project`,
            isRoot: true,
          });
          breadcrumbItems.push({
            name: `/ ${projectDetail?.title} `,
            url: `/project/${projectDetail?.id}/find-covered-product?tab=comparison-library`,
            isProjectTitle: true,
          });
        }
        if (vijilize && vijilize?.title && vijilize?.id) {
          breadcrumbItems.push({
            name: `/ Vijilize / ${vijilize?.title}`,
            url: `/project/${projectDetail?.id}/vijilize/${vijilize?.id}`,
          });
        } else if (claimAnalysis && claimAnalysis?.title && claimAnalysis?.id) {
          breadcrumbItems.push({
            name: `/ Claim Analysis / ${claimAnalysis?.title}`,
            url: `/project/${projectDetail?.id}/patent/${claimAnalysis?.id}/claim-analysis`,
          });
        } else if (claimChart && claimChart?.title && claimChart?.id) {
          breadcrumbItems.push({
            name: `/ Vijil Chart / ${claimChart?.title}`,
            url: `/project/${projectDetail?.id}/claim-chart/${claimChart?.id}`,
          });
        }
      } else if (type === "portfolio" && portfolioDetail) {
        breadcrumbItems.push({
          name: `Portfolio / ${portfolioDetail?.title} `,
          url: `/portfolio/${portfolioDetail?.id}/details`,
        });
      }
    }
  }

  const handleImageError = (e: any) => {
    e.target.src = ""; //allImgPaths.defaultProfileImage
  };

  const profileRef = useRef(null);
  const notiRef = useRef(null);
  const creditWarningRef = useRef(null);
  const walkthroughMenuRef = useRef(null);
  useOnClickOutside(profileRef, () => setisShow(false));
  useOnClickOutside(notiRef, () => setIsShowNotification(false));
  useOnClickOutside(creditWarningRef, () => setShowCreditTooltip(false));
  useOnClickOutside(walkthroughMenuRef, () => setShowWalkthroughMenu(false));

  // Walkthroughs available for the current page.
  const onFindCoveredProductPage = location.pathname.endsWith(
    HELP_BUTTON_PATHS.FIND_COVERED_PRODUCT
  );
  const onVijilizationDetailPage =
    walkthroughState?.page === "vijilization-detail";
  const onViewMoreDetailPage = walkthroughState?.page === "view-more-detail";
  const onAnnotationPage = walkthroughState?.page === "annotation";
  const onHeatmapPage = walkthroughState?.page === "heatmap";
  const walkthroughs: Walkthrough[] = onHeatmapPage
    ? HEATMAP_WALKTHROUGHS
    : onAnnotationPage
    ? ANNOTATION_PAGE_WALKTHROUGHS
    : onViewMoreDetailPage
    ? VIEW_MORE_DETAIL_WALKTHROUGHS
    : onVijilizationDetailPage
    ? VIJILIZATION_DETAIL_WALKTHROUGHS
    : onFindCoveredProductPage
    ? isActiveSection === 1
      ? VIJILIZATIONS_TAB_WALKTHROUGHS
      : FIND_COVERED_PRODUCT_WALKTHROUGHS
    : PROJECT_LIST_WALKTHROUGHS;

  const runTour = (walkthrough: Walkthrough) => {
    if (!walkthrough.steps.length) return;
    // Some tours anchor to elements that only render on a specific sub-tab
    // (e.g. the per-URL monitor icon). Activate it before driving so the
    // element exists by the time its step is reached.
    if (walkthrough.activateUrlsTab) {
      const actions = getWalkthroughActions ? getWalkthroughActions() : {};
      actions?.openCompareUrlsTab?.();
    }
    // Expand the first covered product so the "View More Details" / citation
    // steps have anchors by the time the user advances to them.
    if (walkthrough.expandsFirstTarget) {
      const actions = getWalkthroughActions ? getWalkthroughActions() : {};
      actions?.expandFirstCoveredProduct?.();
    }
    driver({
      showProgress: true,
      steps: walkthrough.steps,
      // Steps flagged with `clickOnHighlight` trigger their target's click when
      // highlighted, so the tour can demonstrate the action live (e.g. clicking
      // a citation superscript opens the Citation panel the next step anchors to).
      // Steps flagged with `triggerDrillOnHighlight` run the heatmap "drill into
      // first patent" action, so the patent click expanding into the claim-level
      // heatmap plays out live on that step.
      onHighlighted: (element, step: any) => {
        if (step?.clickOnHighlight && element) {
          (element as HTMLElement).click();
        }
        if (step?.triggerDrillOnHighlight) {
          const actions = getWalkthroughActions ? getWalkthroughActions() : {};
          actions?.drillIntoFirstPatent?.();
        }
      },
    }).drive();
  };

  // Begin the "How to Vijilize" walkthrough, opening the Add Source / Add
  // Comparison modals first when the prerequisites are missing. Once the user
  // adds the missing item, the gate effect below resumes the flow.
  const beginVijilizeWalkthrough = (walkthrough: Walkthrough) => {
    const actions = getWalkthroughActions ? getWalkthroughActions() : {};
    if (!walkthroughState?.hasSourcePatent) {
      setPendingVijilizeWalkthrough(walkthrough);
      setVijilizeGateStage("await-source");
      actions?.openAddSourcePatent?.();
      return;
    }
    if (!walkthroughState?.hasTarget) {
      setPendingVijilizeWalkthrough(walkthrough);
      setVijilizeGateStage("await-target");
      actions?.openAddCompareTarget?.();
      return;
    }
    runTour(walkthrough);
  };

  const handleSelectWalkthrough = (walkthrough: Walkthrough) => {
    setShowWalkthroughMenu(false);
    if (walkthrough.requiresVijilizeSetup) {
      beginVijilizeWalkthrough(walkthrough);
    } else {
      runTour(walkthrough);
    }
  };

  const clearVijilizeGate = () => {
    if (resumeTimerRef.current) {
      clearTimeout(resumeTimerRef.current);
      resumeTimerRef.current = null;
    }
    addModalWasOpenRef.current = false;
    setVijilizeGateStage(null);
    setPendingVijilizeWalkthrough(null);
  };

  // Resume a gated "How to Vijilize" walkthrough as soon as the awaited
  // prerequisite (source patent, then a target) becomes available.
  useEffect(() => {
    if (!vijilizeGateStage || !pendingVijilizeWalkthrough) return;
    const actions = getWalkthroughActions ? getWalkthroughActions() : {};

    if (vijilizeGateStage === "await-source") {
      if (!walkthroughState?.hasSourcePatent) return;
      if (!walkthroughState?.hasTarget) {
        setVijilizeGateStage("await-target");
        addModalWasOpenRef.current = false;
        actions?.openAddCompareTarget?.();
        return;
      }
    } else if (vijilizeGateStage === "await-target") {
      if (!walkthroughState?.hasTarget) return;
    }

    const walkthrough = pendingVijilizeWalkthrough;
    setVijilizeGateStage(null);
    setPendingVijilizeWalkthrough(null);
    addModalWasOpenRef.current = false;
    // Let the Add modal finish closing before highlighting the page. Held in a
    // ref (cleared on unmount) rather than this effect's cleanup, which would
    // otherwise cancel it when the gate-clearing state change re-runs the effect.
    resumeTimerRef.current = setTimeout(() => runTour(walkthrough), 350);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walkthroughState, vijilizeGateStage, pendingVijilizeWalkthrough]);

  // Abandon a gated walkthrough if the user closes the Add modal without adding
  // the prerequisite. We wait until the modal has been seen open and then closed
  // with the prerequisite still unmet, stable for a grace period — so a
  // successful add's async refresh isn't mistaken for a cancel.
  useEffect(() => {
    if (!vijilizeGateStage) {
      addModalWasOpenRef.current = false;
      return;
    }
    if (walkthroughState?.addPatentModalOpen) {
      addModalWasOpenRef.current = true;
      return;
    }
    if (!addModalWasOpenRef.current) return;

    const stillNeedsSource =
      vijilizeGateStage === "await-source" && !walkthroughState?.hasSourcePatent;
    const stillNeedsTarget =
      vijilizeGateStage === "await-target" && !walkthroughState?.hasTarget;
    if (!stillNeedsSource && !stillNeedsTarget) return;

    const t = setTimeout(() => clearVijilizeGate(), 2500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walkthroughState, vijilizeGateStage]);

  // Abandon any pending gate when the route changes, and cancel a pending tour
  // timer when the Header unmounts.
  useEffect(() => {
    clearVijilizeGate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (resumeTimerRef.current) clearTimeout(resumeTimerRef.current);
    };
  }, []);

  return (
    <div
      id="mah"
      className="header-bar flex items-center justify-between px-6 py-3.5 border-b border-[#E6E6E6]"
    >
      {type && type === "settings" && (
        <span className="text-2xl text-[#091E42] font-interSemiBold">
          Welcome, {userProfile.name}
        </span>
      )}
      {type != "settings" && (
        <>
          {isChildEle && (
            <div className="flex justify-start ">
              <ol className="flex items-center cursor-default">
                {/* <li className='px-1'>
                            <Link to='/' className='text-[#7F7D83] text-sm font-interMedium flex items-center gap-x-1 hover:text-[#113B98] on-hover-blue-child-img'>
                                <img className='' src={allImgPaths.breadCrumbHomeIcon} alt='' />
                                Home
                            </Link>
                        </li> */}
                {breadcrumbItems.map((item, index) => (
                  <li key={item.url + index} className="flex items-center px-0.5">
                    {item.isRoot ? (
                      <Link
                        to={item.url}
                        className="text-[#7F7D83] hover:text-[#113B98] text-sm font-interMedium flex items-center gap-x-1 on-hover-blue-child-img"
                      >
                        <img
                          className=""
                          src={allImgPaths.boxIconGrey}
                          alt=""
                        />
                        {item.name}
                      </Link>
                    ) : item.isProjectTitle ? (
                      <Link
                        to={item.url}
                        className="text-[#7F7D83] hover:text-[#113B98] text-sm font-interMedium"
                      >
                        {item.name}
                      </Link>
                    ) : (
                      <Link
                        to={item.url}
                        className="text-[#7F7D83] hover:text-[#113B98] text-sm font-interMedium"
                      >
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ol>
            </div>
          )}
          {!isChildEle && (
            <div className="">
              <div className="flex items-center gap-x-1">
                <img src={allImgPaths.breadCrumbHomeIcon} alt="" />
                <span className="text-[#7F7D83] font-interMedium text-sm">
                  {title}
                </span>
              </div>
              <div className="flex gap-x-2 items-center">
                <h1 className="text-[#0A090B] font-interSemiBold text-xl">
                  {title}
                </h1>

                <span className="bg-[#EBF0FB] text-[#113B98] rounded-lg py-1 px-2 text-sm font-interMedium">
                  {count} {title}
                </span>
              </div>
            </div>
          )}
        </>
      )}

      <div className="flex items-center gap-x-6">
        {/* Credit Warning */}
        {showCreditWarning && teamCredits !== null && teamCredits < creditThreshold && (
          <div ref={creditWarningRef} className="relative flex items-center">
            <div
              onClick={() => setShowCreditTooltip(!showCreditTooltip)}
              className="flex items-center gap-2 cursor-pointer"
            >
              <span className="relative flex h-3 w-3 flex-shrink-0">
                <span
                  className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
                    teamCredits <= 0 ? "bg-red-400" : "bg-yellow-400"
                  }`}
                />
                <span
                  className={`relative inline-flex rounded-full h-3 w-3 ${
                    teamCredits <= 0 ? "bg-red-500" : "bg-yellow-500"
                  }`}
                />
              </span>
              <span
                className={`text-xs font-interMedium whitespace-nowrap ${
                  teamCredits <= 0 ? "text-red-500" : "text-yellow-600"
                }`}
              >
                {teamCredits <= 0 ? "No credits remaining" : "Low credits"}
              </span>
            </div>

            {showCreditTooltip && (
              <div className="absolute top-full right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg p-4 z-50">
                {teamCredits <= 0 ? (
                  <>
                    <p className="text-sm text-red-500 font-interSemiBold">
                      {isAdmin
                        ? "Oops! You've run out of credits. To keep using ipvijil.ai, please top up your credits."
                        : "Uh-oh! Your team's credits have run out. Please contact your team admin to top up and get back to using ipvijil.ai."}
                    </p>
                    {isAdmin && (
                      <button
                        onClick={() => navigate("/settings?section=billing")}
                        className="mt-2 px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors font-interMedium"
                      >
                        Add Credits
                      </button>
                    )}
                  </>
                ) : (
                  <>
                    <p className="text-sm text-yellow-600 font-interSemiBold">
                      {isAdmin
                        ? "Your team is running low on credits. Top up soon to avoid interruptions."
                        : "Your team's credits are running low. Please notify your team admin to top up."}
                    </p>
                    {isAdmin && (
                      <button
                        onClick={() => navigate("/settings?section=billing")}
                        className="mt-2 px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors font-interMedium"
                      >
                        Add Credits
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        )}

        {/* Guided walkthroughs */}
        {showHelpButton && walkthroughs.length > 0 && (
          <div ref={walkthroughMenuRef} className="relative">
            <button
              onClick={() => setShowWalkthroughMenu((prev) => !prev)}
              title="Guided walkthroughs"
              className={`flex items-center gap-x-1.5 border rounded-lg pl-1.5 pr-2.5 py-1 text-sm font-interMedium transition-colors ${
                showWalkthroughMenu
                  ? "border-[#1751D0] text-[#1751D0] bg-[#F5F8FD]"
                  : "border-[#D0D5DD] text-[#344054] hover:bg-[#F9FAFB]"
              }`}
            >
              <img
                className="w-6 h-6"
                src={allImgPaths.helpIcon}
                alt=""
              />
              Guided walkthroughs
              <KeyboardArrowDownIcon
                sx={{
                  width: 18,
                  height: 18,
                  color: showWalkthroughMenu ? "#1751D0" : "#7F7D83",
                  transform: showWalkthroughMenu ? "rotate(180deg)" : "none",
                  transition: "transform 0.15s",
                }}
              />
            </button>

            {showWalkthroughMenu && (
              <div className="absolute right-0 top-full mt-2 bg-white shadow-customShadow8 rounded-lg z-30 overflow-hidden w-72">
                <div className="px-4 pt-3 pb-2 border-b border-[#EAECF0]">
                  <p className="text-sm font-interSemiBold text-[#101828]">
                    Guided walkthroughs
                  </p>
                  <p className="text-xs text-[#475467]">
                    Take a quick tour of this page.
                  </p>
                </div>
                <div className="py-1 max-h-[360px] overflow-y-auto">
                  {walkthroughs.map((walkthrough) => (
                    <button
                      key={walkthrough.id}
                      onClick={() => handleSelectWalkthrough(walkthrough)}
                      className="w-full flex items-start gap-x-3 px-4 py-2.5 text-left hover:bg-[#F5F8FD] transition-colors"
                    >
                      <PlayCircleOutlineIcon
                        sx={{
                          width: 22,
                          height: 22,
                          color: "#1751D0",
                          marginTop: "1px",
                          flexShrink: 0,
                        }}
                      />
                      <div>
                        <p className="text-sm font-interSemiBold text-[#344054]">
                          {walkthrough.title}
                        </p>
                        <p className="text-xs text-[#7F7D83] font-interRegular">
                          {walkthrough.steps.length}{" "}
                          {walkthrough.steps.length === 1 ? "step" : "steps"}
                        </p>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {showBellIcon && <div ref={notiRef} className="relative">
          <div
            onClick={handleNotificationMenu}
            className="relative inline-block cursor-pointer on-hover-bg-grey w-8 h-8 p-1 rounded"
          >
            <img
              className="w-full h-full"
              src={bellIcon}
              alt="bell icon"
            />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#E12121] text-white text-[10px] font-interSemiBold rounded-full w-4 h-4 flex items-center justify-center">
                +{unreadCount > 9 ? "9" : unreadCount}
              </span>
            )}
          </div>

          <div
            className={`${
              isShowNotification === false ? "hidden" : "inline-block"
            } absolute bg-white right-0 top-full shadow-customShadow8 rounded-lg z-30 overflow-hidden`}
          >
            <div className="w-[400px] rounded-lg">
              <div className="px-6 pt-5 mb-4 flex justify-between items-start">
                <div>
                  <p className="text-xl font-interSemiBold text-[#101828] pb-0.5">
                    Notifications
                  </p>
                  <p className="text-[#475467] text-sm">
                    Keep track of project monitoring updates.
                  </p>
                </div>
                <img
                  onClick={handleNotificationMenu}
                  className="cursor-pointer on-hover-bg-grey w-6 h-6 p-1.5 rounded"
                  src={allImgPaths.closeIcon}
                  alt=""
                />
              </div>

              {notifications.length > 0 && (
                <div className="px-6 mb-3 flex items-center justify-between">
                  <div>
                    {unreadCount > 0 && (
                      <button
                        onClick={markAllAsRead}
                        className="text-sm font-interMedium text-[#1751D0] hover:text-[#113B98] cursor-pointer"
                      >
                        Mark all as read
                      </button>
                    )}
                  </div>
                  <button
                    onClick={clearAllNotifs}
                    className="text-sm font-interMedium text-[#E12121] hover:text-[#B42318] cursor-pointer"
                  >
                    Clear all
                  </button>
                </div>
              )}

              <div className="border-t border-[#EAECF0] max-h-[360px] overflow-y-auto">
                {notifications.length === 0 ? (
                  <div className="px-6 py-8 text-center">
                    <p className="text-sm text-[#7F7D83] font-interRegular">
                      No notifications yet.
                    </p>
                  </div>
                ) : (
                  notifications.map((notif) => (
                    <div
                      key={notif._id || notif.id}
                      onClick={() => {
                        markAsRead(notif._id || notif.id);
                        onNotificationClick?.(notif);
                        setIsShowNotification(false);
                      }}
                      className={`px-6 py-4 flex justify-between items-start border-b border-[#EAECF0] cursor-pointer hover:bg-[#F9FAFB] ${
                        !notif.is_read ? "bg-[#F5F8FD]" : ""
                      }`}
                    >
                      <div className="flex gap-x-3 items-start flex-1">
                        {notif.type === "vijilization_completed" ? (
                          <CheckCircleIcon sx={{ width: 32, height: 32, color: "#047857", marginTop: "2px" }} />
                        ) : (
                          <MonitorIcon sx={{ width: 32, height: 32, color: "#1751D0", marginTop: "2px" }} />
                        )}
                        <div>
                          <div className="flex items-center gap-x-2 mb-0.5">
                            <p className="text-sm font-interSemiBold text-[#344054]">
                              {notif.title}
                            </p>
                            {notif.type === "info_updated" && (
                              <span className="bg-[#ECFDF5] text-[#047857] text-[8px] font-interSemiBold px-1 py-px rounded">
                                Info Updated
                              </span>
                            )}
                            {notif.type === "vijilization_completed" && (
                              <span className="bg-[#ECFDF5] text-[#047857] text-[8px] font-interSemiBold px-1 py-px rounded">
                                Completed
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-[#475467] font-interRegular">
                            {notif.message}
                          </p>
                          <p className="text-xs text-[#ADACB0] font-interRegular mt-1">
                            {new Date(notif.createdAt).toLocaleString()}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-x-2 flex-shrink-0 mt-1">
                        {!notif.is_read && (
                          <span className="w-2.5 h-2.5 rounded-full bg-[#E12121] inline-block"></span>
                        )}
                        <button
                          onClick={(e) => deleteNotif(e, notif._id || notif.id)}
                          className="hover:bg-[#FFF1F2] transition-colors p-1 rounded"
                          title="Delete notification"
                        >
                          <img src={allImgPaths.trashIcon} alt="delete" className="w-3.5 h-3.5 opacity-40 hover:opacity-100" />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>}

        {showMonitorButton && (
          <button
            id="monitor-button"
            onClick={onMonitorClick}
            className={`flex items-center gap-x-1.5 border rounded-lg px-3 py-1.5 text-sm font-interMedium transition-colors ${
              isMonitoringActive
                ? "border-[#1751D0] text-[#1751D0] bg-[#F5F8FD] hover:bg-[#EBF0FB]"
                : "border-[#D0D5DD] text-[#7F7D83] hover:bg-[#F9FAFB]"
            }`}
          >
            <MonitorIcon sx={{ width: 18, height: 18, color: isMonitoringActive ? "#1751D0" : "#ADACB0" }} />
            Monitor
          </button>
        )}

        <div ref={profileRef} className="relative flex-shrink-0">
          <img
            onError={handleImageError}
            onClick={handleProfileMenu}
            className={`inline-block w-10 h-10 rounded-full cursor-pointer on-hover-border-shadow ${
              isShow === false ? "" : "on-hover-border-shadow"
            }`}
            src={userProfile?.profile_image || allImgPaths.defaultProfile}
            alt="profile"
          />

          <div
            className={`${
              isShow === false ? "hidden" : "inline-block"
            } absolute bg-white right-0 top-full shadow-customShadow8 rounded-lg z-30 overflow-hidden`}
          >
            <div className="w-60 rounded-lg">
              <div className="px-4 py-3 flex gap-x-3 border-b border-[#EAECF0]">
                <div className="relative flex-shrink-0">
                  <img
                    className="inline-block w-10 h-10 rounded-full cursor-pointer"
                    src={
                      userProfile?.profile_image || allImgPaths.defaultProfile
                    }
                    alt=""
                  />
                  <span className="w-3.5 h-3.5 border-2 border-white rounded-full bg-[#17B26A] inline-block absolute -bottom-px -right-px"></span>
                </div>
                <div className="">
                  <h4 className="font-interSemiBold text-sm text-[#344054]">
                    {userProfile?.name}
                  </h4>
                  <p
                    title={userProfile?.email}
                    className="text-[#475467] text-sm truncate max-w-40"
                  >
                    {userProfile?.email}
                  </p>
                </div>
              </div>

              <div className="py-3 px-4 border-b border-[#EAECF0]">
                <div className="flex items-center gap-x-2 cursor-pointer w-fit on-hover-blue">
                  {/* <img className="inline-block w-7 h-7 rounded-full" src={userProfile?.profile_image || allImgPaths.defaultProfileImage} alt="" /> */}
                  <img
                    className="w-4 h-4"
                    src={allImgPaths.profileImgNew}
                    alt="profile img"
                  />
                  <h4
                    onClick={() => {
                      setShowUserProfile(true);
                    }}
                    className="text-sm font-interMedium text-[#344054] on-hover-blue cursor-pointer"
                  >
                    Profile
                  </h4>
                </div>
              </div>

              <div className="">
                {/* <div className="bg-[#f9fafb] pt-3">
									<h3 className="text-[#98A2B3] text-sm pb-4 pl-3.5">SWITCH ACCOUNTS</h3>
									<div className="flex gap-x-2 border-b border-[#dcdcdc] pb-3 first:pt-0 pl-4 pr-3">
										<span className="uppercase text-sm text-[#363F72] font-interSemiBold border border-[#D6BBFB] bg-[#F9F5FF] rounded-full w-8 h-8 flex items-center justify-center -mt-1.5">OR</span>
										<div className="">
											<h6 className="text-sm font-interMedium text-[#344054] pb-1.5">Olivia Rhye</h6>
											<p className="text-xs text-[#98A2B3]">Olivia@eventsprite.com</p>
										</div>
									</div>
								</div>


								<div className="flex gap-x-2 pt-5 pb-5 first:pt-0 pl-4 pr-3 bg-[#f9fafb]">
									<span className="uppercase text-sm text-[#E62E05] font-interSemiBold border border-[#F7B27A] bg-[#FEF6EE] rounded-full w-8 h-8 flex items-center justify-center -mt-1.5">OR</span>
									<div className="">
										<h6 className="text-sm font-interMedium text-[#344054] pb-1.5">Olivia Rhye</h6>
										<p className="text-xs text-[#98A2B3]">Olivia@eventsprite.com</p>
									</div>
								</div> */}

                {/* <div className="px-4 border-b border-[#EAECF0] pb-4 bg-[#f9fafb]">
									<div className="flex gap-x-2 cursor-pointer w-fit on-hover-blue">
										<img src={allImgPaths.plusIcon6} alt="" />
										<h4 className="font-interMedium text-sm text-[#344054]">Add account</h4>
									</div>
								</div> */}

                <div className="py-3 px-4 border-b border-[#EAECF0]">
                  <div className="flex gap-x-2 cursor-pointer w-fit on-hover-blue">
                    <img
                      className="w-4 h-4"
                      src={allImgPaths.EditIcon}
                      alt=""
                    />
                    <h4
                      onClick={() => {
                        setShowChangePassword(true);
                      }}
                      className="font-interMedium text-sm text-[#344054]"
                    >
                      Change Password
                    </h4>
                  </div>
                </div>

                <div className="py-3 px-4 flex gap-x-3 rounded-bl-xl rounded-br-xl overflow-hidden">
                  <div
                    className="flex gap-x-2 cursor-pointer w-fit on-hover-blue"
                    onClick={handleLogout}
                  >
                    <img src={allImgPaths.logOutIcon} alt="" />
                    <h4 className="font-interMedium text-sm text-[#344054]">
                      Logout
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TODO:  */}
      {showUserProfile && (
        <UserProfile
          isShow={showUserProfile}
          setIsShow={setShowUserProfile}
          setFetchNewData={setFetchNewData}
        />
      )}

      {showChangePassword && (
        <ChangePassword
          isShow={showChangePassword}
          setIsShow={setShowChangePassword}
          setFetchNewData={setFetchNewData}
        />
      )}
    </div>
  );
};

export default Header;
